<template>
  <div class="container_box">
    <div class="bg">
      <img src="../assets/imgs/banner1-1.png" alt="" />
    </div>
    <div class="content">
      <div class="bold9 size20 color1">
        关于我们
        <!-- <span style="font-size: 14px; color: #ccd9e9">About Us</span> -->
      </div>

      <!-- 内容 -->
      <div
        class="flex"
        style="
          background-color: #fff;
          margin-top: 20px;
          padding-bottom: 30px;
          min-height: 737px;
        "
      >
        <div class="left" style="position: relative">
          <div
            class="divider"
            style="position: absolute; top: 37px; left: 43px"
          ></div>
          <!-- <div
            class="divider"
            style="position: absolute; top: 90px; left: 43px"
          ></div> -->
          <!-- 左侧导航：联系我们 -->
          <div class="flex mb-32">
            <div class="smallBox"></div>
            <span
              class="text"
              :class="[isActive == 2 ? 'active' : '']"
              @click="tabChange"
              data-id="2"
              >联系我们</span
            >
          </div>
          <!-- 左侧导航：供应商服务 -->
          <!-- <div class="flex mb-32">
            <div class="smallBox"></div>
            <span
              class="text"
              :class="[isActive == 3 ? 'active' : '']"
              @click="tabChange"
              data-id="3"
              >供应商服务</span
            >
          </div> -->
          <!-- 左侧导航：操作指南-->
          <div class="flex mb-32">
            <div class="smallBox"></div>
            <span
              class="text"
              :class="[isActive == 4 ? 'active' : '']"
              @click="tabChange"
              data-id="4"
              >操作指南</span
            >
          </div>
        </div>
        <div class="right" v-show="tab == 1">
          <img src="../assets/imgs/us.png" alt="" />
          <div class="us">关于我们</div>

          <div
            v-html="about"
            class="ql-editor"
            style="line-height: 2em; text-indent: 2em"
          ></div>
        </div>
        <!-- 联系我们内容 -->
        <div class="right" v-show="tab == 2">
          <div class="title">联系我们</div>
          <div class="flex between">
            <div id="dituContent"></div>
            <div
              class="flex flex-column flex-center"
              style="
                width: 200px;
                font-size: 16px;
                color: #3b426b;
                line-height: 2em;
              "
            >
              <span>咨询电话：<br />{{ pingTaiInfo.telphone }} <br />15513625276 </span>
<!--              <span class="wz"
                >官方网站： <br />
                {{ pingTaiInfo.officalWebsite }}/<br
              /></span> -->
              <span>官方邮箱：<br />{{ pingTaiInfo.officicalEmail }} </span>
              <span>联系地址：<br />{{ pingTaiInfo.concatAddress }}</span>
            </div>
          </div>
        </div>
        <!-- 供应商服务 -->
        <div class="right" style="padding-bottom: 20px" v-show="tab == 3">
          <div class="title">供应商服务</div>
          <el-table
            :data="gysTableData"
            :show-header="hiddenTableHeader"
            :cell-style="cellStyle"
            style="width: 100%"
          >
            <el-table-column prop="manualName"></el-table-column>
            <el-table-column style="text-align: right">
              <template slot-scope="scope">
                <div
                  style="margin-left: 280px"
                  class="download"
                  @click="shouceDownload(scope.row)"
                >
                  下载
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 操作指南 -->
        <div class="right" style="padding-bottom: 20px" v-show="tab == 4">
          <div class="title">操作指南</div>
          <el-table
            :data="czTableData"
            :show-header="hiddenTableHeader"
            :cell-style="cellStyle"
            style="width: 100%"
          >
            <el-table-column prop="manualName"> </el-table-column>
            <el-table-column style="text-align: right">
              <template slot-scope="scope">
                <div
                  style="margin-left: 280px"
                  class="download"
                  @click="zhinanDownload(scope.row)"
                >
                  下载
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <Footer class="mt-15" />
  </div>
</template>
<script type="text/javascript" src="https://api.map.baidu.com/api?key=&v=1.1&services=true"></script>

<script>
import Footer from "@/components/Footer";

export default {
  components: { Footer },

  data() {
    return {
      hiddenTableHeader: false,
      tab: 1,
      isActive: 1,
      gysTableData: [],
      czTableData: [],
      about: "",
      pingTaiInfo: {},
      cellStyle: {},
      map: {},
      mk: {},
      markerArr: [
        {
          title: "山西筑创科技有限公司",
          content: "山西筑创科技有限公司",
          point: "113.135613|36.221343",
          isOpen: 0,
          icon: { w: 21, h: 21, l: 0, t: 0, x: 6, lb: 5 },
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.getMeData();
    this.getPingTaiInfo();
    this.getManualInfo();
    this.getManualInfo1();

    this.$nextTick(() => {});
  },
  methods: {
    //地图相关
    drawMap() {
      setTimeout(() => {
        this.map = new BMap.Map("dituContent");

        var point = new BMap.Point(112.535264, 37.816645);
        this.map.centerAndZoom(point, 15);
        // this.map.setCurrentCity("长治"); // 设置地图显示的城市 此项是必须设置的
        // //添加地图类型控件
        // this.map.addControl(
        //   new BMap.MapTypeControl({
        //     mapTypes: ["BMAP_NORMAL_MAP", "BMAP_HYBRID_MAP"],
        //   })
        // );
        // this.map.setCurrentCity("长治"); // 设置地图显示的城市 此项是必须设置的
        this.map.enableScrollWheelZoom(true);
        var marker = new BMap.Marker(point); // 创建标注
        this.map.addOverlay(marker); // 将标注添加到地图中
        this.map.addControl(new BMap.NavigationControl());
        // this.map.enableScrollWheelZoom(true);
      }, 1000);
    },

    //获取(操作手册)
    async getManualInfo() {
      const { data: res } = await this.$axios.get(
        "/api/platInfo/getManualInfo",
        {
          params: {
            type: 1,
          },
        }
      );
      //console.log(res)
      if (res.code == 200) {
        this.czTableData = res.data;
      } else {
        console.log(res.msg);
        return;
      }
    },
    //获取(供应商手册手册)
    async getManualInfo1() {
      const { data: res } = await this.$axios.get(
        "/api/platInfo/getManualInfo",
        {
          params: {
            type: 2,
          },
        }
      );
      if (res.code == 200) {
        this.gysTableData = res.data;
      } else {
        console.log(res.msg);

        return;
      }
    },
    resultClose() {
      this.resultShow = false;
    },
    //获取平台信息
    async getPingTaiInfo() {
      const { data: res } = await this.$axios.get("/api/platInfo/getPlatInfo");
      //console.log(res)
      this.pingTaiInfo = res.data;
    },
    //获取关于我们
    async getMeData() {
      const { data: res } = await this.$axios.get("/api/platInfo/getAboutUs");
      //console.log(res)
      if (res.code == 200) {
        this.about = res.data;
      } else {
        console.log(res.msg);

        return;
      }
    },
    tabChange(e) {
      let tabid = e.target.dataset.id;
      if (tabid == 2) {
        this.drawMap();
      }
      this.tab = tabid;

      this.isActive = tabid;
    },
    //指南下载
    zhinanDownload(row) {
      // let url = row.manualUrl.replace("/profile/upload", "");
	  let url = row.manualUrl.slice(row.manualUrl.indexOf("/profile/upload") + 15);
      // window.open("http://81.70.253.119:8081/common/download?fileName=" + url);
	  window.open(this.$static.SERVER_URL + "/common/download?fileName=" + url);
    },
    //手册下载
    shouceDownload() {
      window.open(row.manualUrl);
    },
  },
};
</script>

<style scoped lang="less">
.ql-editor {
  white-space: normal !important;
}

.ql-container {
  white-space: pre-wrap !important;
}
#dituContent {
  width: 760px;
  margin-right: 30px;
  height: 400px;
}
.iw_poi_title {
  color: #cc5522;
  font-size: 14px;
  font-weight: bold;
  overflow: hidden;
  padding-right: 13px;
  white-space: nowrap;
}
.iw_poi_content {
  font: 12px arial, sans-serif;
  overflow: visible;
  padding-top: 4px;
  white-space: -moz-pre-wrap;
  word-wrap: break-word;
}
.wz {
  word-wrap: break-word;
  width: 100%;
}
.content {
  width: 1200px;
  margin: auto;
}
/deep/.el-table td.el-table__cell {
  border-bottom: 2px solid #95b3db;
  padding: 26px 0 29px 0;
}

/deep/.el-table .cell {
  padding: 0 40px;
  color: #1c65c4;
}
/deep/.el-table__row:hover > td {
  background-color: #ffffff !important;
}
/deep/.el-table::before {
  height: 0;
  border-bottom: 2px solid #fff;
}
.left {
  width: 260px;
  box-sizing: border-box;
  padding-left: 40px;
  padding-top: 20px;

  .divider {
    width: 1px;
    height: 42px;
    background-color: #95b3db;
  }
  .mb-32 {
    margin-bottom: 32px;
    .smallBox {
      width: 6px;
      height: 6px;
      border: 1px solid #95b3db;
      margin-right: 10px;
      margin-top: 8px;
    }
    .text {
      font-size: 16px;
      color: #95b3db;
      cursor: pointer;
    }
    .main {
      width: 940px;
      position: absolute;
      top: 0px;
      left: 260px;
      background-color: #fff;
      box-sizing: border-box;
      padding-top: 20px;
      padding-right: 40px;
    }
  }
}
.right {
  width: 940px;
  box-sizing: border-box;
  padding-top: 25px;
  padding-right: 40px;
  .title {
    font-size: 20px;
    font-weight: bold;
    color: #3b426b;
    margin-left: 411px;
    margin-bottom: 20px;
  }
  .list {
    margin-bottom: 25px;
    box-sizing: border-box;
    padding: 0 40px 25px 40px;
    border-bottom: 2px solid #95b3db;
  }
  .titleText {
    font-size: 16px;
    color: #1c65c4;
    cursor: pointer;
    margin-top: 7px;
  }
  .download {
    width: 90px;
    height: 30px;
    border-radius: 10px;
    font-size: 14px;
    background-color: #1c65c4;
    color: #fff;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }
  .us {
    font-size: 20px;
    margin: 29px 0 20px 412px;
    color: #3b426b;
    font-weight: bold;
  }
}

.active {
  color: #1c65c4 !important;
}
/deep/.el-divider--horizontal {
  height: 2px;
  background-color: #95b3db;
}
.border {
  border: none !important;
}
</style>